import { connect } from "react-redux"
import React, { Component } from "react"
import Exhibition from "./components/Exhibition"
import program from "./program"

console.log(program.subtitles.filter(subtitle => subtitle.end - subtitle.start < 2))
// import calculateTimecode from "./calculateTimecodes"

const mapStateToProps = () => ({})

@connect(mapStateToProps, { })
export default class App extends Component {
  render () {
    // const processedLecture = { ...program, subtitles: calculateTimecode(program.subtitles) }
    const processedLecture = { ...program, subtitles: program.subtitles }
    return <Exhibition lecture={processedLecture} />
  }
}



// WEBPACK FOOTER //
// ./src/App.jsx